import { jsx as _jsx } from "react/jsx-runtime";
import { ElementOrIcon } from '@kubit/web-ui-components/elementOrIcon';
import { useTheme } from 'styled-components';
import { BadgeIcon } from '../../badgeIcon/badgeIcon';
import { BadgeLogo } from '../../badgeLogo/badgeLogo';
export const CustomContent = ({ badgeLogo, badgeIcon, selectorIcon, selected, disabled, }) => {
    const theme = useTheme();
    if (badgeLogo) {
        return _jsx(BadgeLogo, { component: "span", ...badgeLogo });
    }
    if (badgeIcon) {
        return _jsx(BadgeIcon, { as: "span", ...badgeIcon });
    }
    if (selected && selectorIcon?.icon) {
        return (_jsx(ElementOrIcon, { color: !disabled
                ? theme.color_comp_resources_selectionindicator_default_selected_icon
                : theme.color_accent_disabled_icon_50, height: theme.size_250, width: theme.size_250, ...selectorIcon }));
    }
    return null;
};
//# sourceMappingURL=customContent.js.map